import { useEffect, useState } from "react"

const UiToggle = ({setToggle}) => {

    const [state, setState] = useState(true)

    useEffect(() => {
        if(setToggle) setToggle(state) 
    }, [state])
    return (
        <div className="d-flex justify-content-end" style={{cursor: "pointer", borderRadius: 120, height: 40, border: "1px solid #650260", padding: 3, backgroundColor: state ? "#650260" : "white" }} onClick={() => setState(old => !old)}>
            {state && <p className="text-white fw-semibold poppins align-self-center mb-0 mx-2">Active</p>}
            <div className="align-self-center" style={{ borderRadius: 100, height: 34, width: 34, backgroundColor: !state ? "#650260" : "white" }}></div>
            {!state && <p className="poppins align-self-center mb-0 mx-2 text-secondary fw-semibold" >Inactive</p>}
        </div>
    )
}

export default UiToggle